import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import { useAppSelector } from '../redux/hooks'

import './styles/Profile.scss'

const Profile = () => {
  const auth = useAppSelector((state) => state.authReducer)
  const favs = useAppSelector((state) => state.favoriteReducer)
  const navigation = useNavigate()
  useEffect(()=> {
    if(!auth.user) navigation('/login')
  }, [auth, navigation])
  return (
    <main>
      <Breadcrumbs/>
      <section>
        <div className="profile">
          <div className="container">
            <h1>My Profile</h1>
            <div className="profile-wrapper">
              <div className="profile-extra">
                <div className="profile-extra-photo">
                  <div className="image">
                    <img src={auth.user?.avatar} alt="" />
                  </div>
                  <div className="profile-extra-name">
                    <p>{auth.user?.name}</p>
                  </div>
                </div>
                <div className="profile-extra-favorites">
                  <h2>My Wish List</h2>
                  {favs.length > 0 ? favs.map(item => (
                    <div className='profile-extra-favorites-item' key={item.id}>
                      <div className="image">
                        <img src={item.images[0]} alt={item.title} />
                      </div>
                      <div className="profile-extra-favorites-info">
                        <h4>{item.title}</h4>
                        <Link to={`/products/${item.id}`}>View page</Link>
                      </div>
                    </div>
                  )) : <p className='profile-extra-favorites__empty'>You have no items in your wish list.</p>}
                </div>
              </div>
              <div className="profile-main">
                <div className="profile-main-category">
                  <div className="profile-main-category__title">
                    <h2>Account Information</h2>
                  </div>
                  <div className="profile-main-category-content">
                    <div className="profile-main-category-content-item">
                      <h3>Contact Information</h3>
                      <p>{auth.user?.name}</p>
                      <p>{auth.user?.email}</p>
                    </div>
                    <div className="profile-main-category-content-item">
                      <h3>Newsletter</h3>
                      <p>You don't subscribe to our newsletter.</p>
                    </div>
                  </div>
                </div>
                <div className="profile-main-category">
                  <div className="profile-main-category__title">
                    <h2>Address Book</h2>
                  </div>
                  <div className="profile-main-category-content">
                    <div className="profile-main-category-content-item">
                      <h3>Default Billing Address</h3>
                      <p>You have not set a default billing address.</p>
                    </div>
                    <div className="profile-main-category-content-item">
                      <h3>Default Shipping Address</h3>
                      <p>You have not set a default shipping address.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default Profile